<template>
  <UIButton
    v-if="!isReadonly"
    :size
    :leading="ArrowDownTrayIcon"
    :label="shrink ? undefined : 'Import'"
    variant="gray"
    fill="light"
    hide-label-to-sm
  />
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { ButtonSize, ReadonlyMode } from '@types'

import { READONLY_MODE } from '@/const/common'

import { ArrowDownTrayIcon } from '@heroicons/vue/24/outline'

import { UIButton } from '@ui/buttons'

type Props = {
  shrink?: boolean
}

const { shrink } = defineProps<Props>()

const size = inject<ButtonSize>('size')
const isReadonly = inject<ReadonlyMode>(READONLY_MODE)
</script>
